import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import FooterColumnHeading from './FooterColumnHeading';
import { FOOTER_LIST_SX, FOOTER_LINK_SX } from './styles';

function LinkColumn({
    heading, links, testId, showHeading = true, slotBeforeLastLink = null,
}) {
    const lastIndex = links.length - 1;

    return (
        <Box data-testid={testId}>
            {showHeading ? <FooterColumnHeading>{heading}</FooterColumnHeading> : null}
            <Box component="ul" sx={FOOTER_LIST_SX}>
                {links.map((link, index) => (
                    <React.Fragment key={link.href}>
                        {slotBeforeLastLink && index === lastIndex ? (
                            <Box component="li">{slotBeforeLastLink}</Box>
                        ) : null}
                        <Box component="li">
                            <Box
                                component="a"
                                href={link.href}
                                target={link.external ? '_blank' : undefined}
                                rel={link.external ? 'noopener noreferrer' : undefined}
                                sx={FOOTER_LINK_SX}
                            >
                                {link.label}
                            </Box>
                        </Box>
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    );
}

LinkColumn.propTypes = {
    heading: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
            external: PropTypes.bool,
        }),
    ).isRequired,
    testId: PropTypes.string.isRequired,
    showHeading: PropTypes.bool,
    slotBeforeLastLink: PropTypes.node,
};

export default LinkColumn;
